module.exports = __webpack_public_path__ + "static/img/应用数据4.21c1e17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-2/应用数据4.png
// module id = ADFn
// module chunks = 0